export enum FinalDestination {
  cemetery = 'CEMENTERIO',
  crematory = 'CREMATORIO'
}
